import React from 'react';
import { Form } from 'react-bootstrap';
export const AcFormFieldErrorMessage = ({ messageId = '' }) => {
    if (typeof messageId === 'string') {
        const messages = messageId.split('\n');
        return (React.createElement(Form.Control.Feedback, { type: "invalid", style: { display: 'block' } }, messages.map((message, i) => (React.createElement("div", { key: i }, message)))));
    }
    return (React.createElement(Form.Control.Feedback, { type: "invalid", style: { display: 'block' } }, messageId));
};
AcFormFieldErrorMessage.displayName = 'AcFormFieldErrorMessage';
